import Types from "./types";

const scriptLoaded = (script, status) => ({
    type: Types.SCRIPT_LOADED,
    data: {
        [script]: status
    }
});

export {
    scriptLoaded
};
